const resource = '/admin/v1/document-templates';

export default $axios => ({
  index(payload) {
    return $axios.post(`${resource}/search`, payload);
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  }
});
